export const FETCH_RESOURCES = 'fetchResources';
export const FETCH_ALL_RESOURCES = 'fetchAllResources';
export const FIND_RESOURCE = 'findResource';
export const DELETE_RESOURCE = 'deleteResource';
export const CREATE_RESOURCE = 'createResource';
export const CREATE_RESOURCE_TYPE = 'createResourceType';
export const UPDATE_RESOURCE_TYPE = 'updateResourceType';
export const DELETE_RESOURCE_TYPE = 'deleteResourceType';
export const UPDATE_RESOURCE = 'updateResource';
export const CLEAR_RESOURCE = 'clearResource';
export const FETCH_SKELETONS_TYPES = 'fetchSkeletonsTypes';
export const FETCH_ANIMATIONS_TYPES = 'fetchAnimationsTypes';
export const FETCH_ANIMATIONS = 'fetchAnimations';
export const FETCH_POSES_TYPES = 'fetchPosesTypes';
